// extracted by mini-css-extract-plugin
export default {"h4":"OverwriteProfile_h4__hhios","modal":"OverwriteProfile_modal__o6Pub","modalDialog":"OverwriteProfile_modalDialog__YVQLq","button":"OverwriteProfile_button__ve7OI"};